<script>
export default {
  name: 'LoginFormItemInputAccount',
  props: {
    value: {
      type: String,
      default: '',
    },
    loginMethod: {
      type: String,
      required: true,
    },
  },
  emits: ['click:change'],
  computed: {
    changeText() {
      return this.loginMethod === 'email'
        ? this.$t('change_email')
        : this.$t('change_phone_number')
    },
  },
}
</script>

<template>
  <div class="tamara-login-form__item__account">
    <div dir="ltr" class="tamara-login-form__item__account__info">
      {{ value }}
    </div>
    <div
      class="tamara-login-form__item__account__change-info"
      @click="$emit('click:change')"
    >
      {{ changeText }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-login-form__item__account {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 20px;
  background-color: #f5f5ff;
  border-radius: 12px;

  &__info {
    @extend .tamara-title-medium;

    color: #202442;
  }

  &__change-info {
    @extend .tamara-title-medium;

    color: var(--tamara-color-text-highlight-primary);
    cursor: pointer;
  }
}
</style>
